export {Ng2Notify} from './directives/ng2-notify';
export {Ng2NotifyService} from './services/ng2-notify';